import useAsync from './useAsync';
import locationAndRoutesStore from '../Models/LocationAndRoutesStore';

/**
 * Call this hook in your component to for a re-render when add on store finishes fetching data.
 */
export default function useLocationAndRoutes(refresh: boolean = false) {
	return useAsync(() => locationAndRoutesStore.retrieveAsync(refresh), []);
}
